import { styled } from "@mui/material";

import { RichTextEditor } from "mui-tiptap";

const baseFontFamily =
  'system-ui, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", Arial, sans-serif !important';
const baseTypography = {
  fontFamily: baseFontFamily,
  fontSize: "0.875rem !important",
  lineHeight: 1.5,
};

export const StyledRichTextEditor = styled(RichTextEditor)(() => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  "& .MuiBox-root": {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  "& .ProseMirror": {
    flex: 1,
    overflowY: "auto",
    ...baseTypography,
    color: "inherit",

    "& ul": {
      listStyleType: "disc",
      paddingLeft: "2em",
    },

    "& ol": {
      listStyleType: "decimal",
      paddingLeft: "2em",
    },

    "& li": {
      display: "list-item",
    },

    "& strong, & b": {
      fontWeight: 700,
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
    },
  },

  "& .MuiInputBase-root": {
    ...baseTypography,

    "&:focus-within": {
      outline: "none",
    },

    "& .MuiInputBase-input": {
      ...baseTypography,
      "&:focus": {
        outline: "none",
      },
    },
  },
}));
